var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e8e4da",
    fillRule: "evenodd",
    d: "M3.728 14.002a7.44 7.44 0 0 0 3.78.998 7.43 7.43 0 0 0 3.764-.998 7.84 7.84 0 0 0 2.73-2.73A7.4 7.4 0 0 0 15 7.509c0-1.366-.333-2.626-.998-3.764a7.55 7.55 0 0 0-2.73-2.73A7.27 7.27 0 0 0 7.509 0c-1.366 0-2.626.332-3.78 1.015a7.56 7.56 0 0 0-2.732 2.73C.332 4.883 0 6.143 0 7.51c0 1.365.332 2.607.997 3.763a7.84 7.84 0 0 0 2.731 2.73zm3.973-11.5c.56 0 1.12.14 1.663.403.542.262.98.648 1.347 1.138.368.49.543 1.015.543 1.593 0 .28-.035.542-.123.787a2.7 2.7 0 0 1-.28.595c-.087.14-.244.298-.42.455-.192.175-.35.28-.454.35-.123.07-.28.158-.49.28a1.56 1.56 0 0 0-.526.491q-.21.288-.21.473a.33.33 0 0 1-.088.227.33.33 0 0 1-.226.088H6.563a.33.33 0 0 1-.227-.088.33.33 0 0 1-.088-.227v-.35c0-.438.175-.841.508-1.226.35-.385.717-.665 1.138-.84.315-.158.525-.298.665-.438a.93.93 0 0 0 .193-.595q0-.341-.369-.577a1.4 1.4 0 0 0-.84-.263 1.6 1.6 0 0 0-.84.227c-.21.158-.49.473-.84.91a.3.3 0 0 1-.245.123.27.27 0 0 1-.175-.07l-1.295-.98c-.14-.105-.175-.245-.07-.403C4.9 3.203 6.108 2.502 7.7 2.502zm-1.453 7.825c0-.088.036-.176.088-.228a.33.33 0 0 1 .227-.087h1.874a.33.33 0 0 1 .226.087.33.33 0 0 1 .089.228v1.855a.33.33 0 0 1-.089.228.33.33 0 0 1-.226.087H6.563a.33.33 0 0 1-.227-.087.34.34 0 0 1-.088-.228z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.68899b647edc732f7cf9ca28688d82eb.svg";
export { ForwardRef as ReactComponent };